{
	"Settings":
	{
		"ENVIRONMENT": "stage",
		"PLATFORM": "WEB",
		"DEFAULT_LANG": "et_EE",
		"DeviceLanguages": 
		{
			"minudoc.ee": ["en_GB", "et_EE", "ru_RU"],
			"siffi.com": ["en_GB", "fi_FI", "et_EE", "ru_RU", "de_DE", "sv_SE", "lv_LV", "lt_LT", "es_ES", "fr_FR"],
			"minudoc.fi": ["en_GB", "fi_FI"],
			"minudoc.pl": ["en_GB", "pl_PL", "ru_RU"],
			"minudoc.lv": ["en_GB", "lv_LV", "ru_RU"],
			"minudoc.lt": ["en_GB", "lt_LT", "ru_RU"]
		},
		"Languages":
		{
			"et_EE":
			{
				"label": "EST",
				"icon": "ee"
			},
			"en_GB":
			{
				"label": "ENG",
				"icon": "gb"
			},
			"fi_FI":
			{
				"label": "FIN",
				"icon": "fi"
			},
			"ru_RU":
			{
				"label": "РУС",
				"icon": "ru"
			},
			"sv_SE":
			{
				"label": "SWE",
				"icon": "se"
			},
			"lv_LV":
			{
				"label": "LVA",
				"icon": "lv"
			},
			"lt_LT":
			{
				"label": "LTU",
				"icon": "lt"
			},
			"de_DE":
			{
				"label": "DEU",
				"icon": "de"
			},
			"es_ES":
			{
				"label": "ESP",
				"icon": "es"
			},
			"fr_FR":
			{
				"label": "FRA",
				"icon": "fr"
			}
		},
		"CountryPhoneCodes": [
			{
				"id":0,
				"name":"+93 Afghanistan [AF]",
				"country":"Afghanistan",
				"dialCode":"+93",
				"countryCode":"AF"
			},
			{
				"id":1,
				"name":"+358 Aland Islands [AX]",
				"country":"Aland Islands",
				"dialCode":"+358",
				"countryCode":"AX"
			},
			{
				"id":2,
				"name":"+355 Albania [AL]",
				"country":"Albania",
				"dialCode":"+355",
				"countryCode":"AL"
			},
			{
				"id":3,
				"name":"+213 Algeria [DZ]",
				"country":"Algeria",
				"dialCode":"+213",
				"countryCode":"DZ"
			},
			{
				"id":4,
				"name":"+1684 AmericanSamoa [AS]",
				"country":"AmericanSamoa",
				"dialCode":"+1684",
				"countryCode":"AS"
			},
			{
				"id":5,
				"name":"+376 Andorra [AD]",
				"country":"Andorra",
				"dialCode":"+376",
				"countryCode":"AD"
			},
			{
				"id":6,
				"name":"+244 Angola [AO]",
				"country":"Angola",
				"dialCode":"+244",
				"countryCode":"AO"
			},
			{
				"id":7,
				"name":"+1264 Anguilla [AI]",
				"country":"Anguilla",
				"dialCode":"+1264",
				"countryCode":"AI"
			},
			{
				"id":8,
				"name":"+672 Antarctica [AQ]",
				"country":"Antarctica",
				"dialCode":"+672",
				"countryCode":"AQ"
			},
			{
				"id":9,
				"name":"+1268 Antigua and Barbuda [AG]",
				"country":"Antigua and Barbuda",
				"dialCode":"+1268",
				"countryCode":"AG"
			},
			{
				"id":10,
				"name":"+54 Argentina [AR]",
				"country":"Argentina",
				"dialCode":"+54",
				"countryCode":"AR"
			},
			{
				"id":11,
				"name":"+374 Armenia [AM]",
				"country":"Armenia",
				"dialCode":"+374",
				"countryCode":"AM"
			},
			{
				"id":12,
				"name":"+297 Aruba [AW]",
				"country":"Aruba",
				"dialCode":"+297",
				"countryCode":"AW"
			},
			{
				"id":13,
				"name":"+61 Australia [AU]",
				"country":"Australia",
				"dialCode":"+61",
				"countryCode":"AU"
			},
			{
				"id":14,
				"name":"+43 Austria [AT]",
				"country":"Austria",
				"dialCode":"+43",
				"countryCode":"AT"
			},
			{
				"id":15,
				"name":"+994 Azerbaijan [AZ]",
				"country":"Azerbaijan",
				"dialCode":"+994",
				"countryCode":"AZ"
			},
			{
				"id":16,
				"name":"+1242 Bahamas [BS]",
				"country":"Bahamas",
				"dialCode":"+1242",
				"countryCode":"BS"
			},
			{
				"id":17,
				"name":"+973 Bahrain [BH]",
				"country":"Bahrain",
				"dialCode":"+973",
				"countryCode":"BH"
			},
			{
				"id":18,
				"name":"+880 Bangladesh [BD]",
				"country":"Bangladesh",
				"dialCode":"+880",
				"countryCode":"BD"
			},
			{
				"id":19,
				"name":"+1246 Barbados [BB]",
				"country":"Barbados",
				"dialCode":"+1246",
				"countryCode":"BB"
			},
			{
				"id":20,
				"name":"+375 Belarus [BY]",
				"country":"Belarus",
				"dialCode":"+375",
				"countryCode":"BY"
			},
			{
				"id":21,
				"name":"+32 Belgium [BE]",
				"country":"Belgium",
				"dialCode":"+32",
				"countryCode":"BE"
			},
			{
				"id":22,
				"name":"+501 Belize [BZ]",
				"country":"Belize",
				"dialCode":"+501",
				"countryCode":"BZ"
			},
			{
				"id":23,
				"name":"+229 Benin [BJ]",
				"country":"Benin",
				"dialCode":"+229",
				"countryCode":"BJ"
			},
			{
				"id":24,
				"name":"+1441 Bermuda [BM]",
				"country":"Bermuda",
				"dialCode":"+1441",
				"countryCode":"BM"
			},
			{
				"id":25,
				"name":"+975 Bhutan [BT]",
				"country":"Bhutan",
				"dialCode":"+975",
				"countryCode":"BT"
			},
			{
				"id":26,
				"name":"+591 Bolivia, Plurinational State of [BO]",
				"country":"Bolivia, Plurinational State of",
				"dialCode":"+591",
				"countryCode":"BO"
			},
			{
				"id":27,
				"name":"+387 Bosnia and Herzegovina [BA]",
				"country":"Bosnia and Herzegovina",
				"dialCode":"+387",
				"countryCode":"BA"
			},
			{
				"id":28,
				"name":"+267 Botswana [BW]",
				"country":"Botswana",
				"dialCode":"+267",
				"countryCode":"BW"
			},
			{
				"id":29,
				"name":"+55 Brazil [BR]",
				"country":"Brazil",
				"dialCode":"+55",
				"countryCode":"BR"
			},
			{
				"id":30,
				"name":"+246 British Indian Ocean Territory [IO]",
				"country":"British Indian Ocean Territory",
				"dialCode":"+246",
				"countryCode":"IO"
			},
			{
				"id":31,
				"name":"+673 Brunei Darussalam [BN]",
				"country":"Brunei Darussalam",
				"dialCode":"+673",
				"countryCode":"BN"
			},
			{
				"id":32,
				"name":"+359 Bulgaria [BG]",
				"country":"Bulgaria",
				"dialCode":"+359",
				"countryCode":"BG"
			},
			{
				"id":33,
				"name":"+226 Burkina Faso [BF]",
				"country":"Burkina Faso",
				"dialCode":"+226",
				"countryCode":"BF"
			},
			{
				"id":34,
				"name":"+257 Burundi [BI]",
				"country":"Burundi",
				"dialCode":"+257",
				"countryCode":"BI"
			},
			{
				"id":35,
				"name":"+855 Cambodia [KH]",
				"country":"Cambodia",
				"dialCode":"+855",
				"countryCode":"KH"
			},
			{
				"id":36,
				"name":"+237 Cameroon [CM]",
				"country":"Cameroon",
				"dialCode":"+237",
				"countryCode":"CM"
			},
			{
				"id":37,
				"name":"+1 Canada [CA]",
				"country":"Canada",
				"dialCode":"+1",
				"countryCode":"CA"
			},
			{
				"id":38,
				"name":"+238 Cape Verde [CV]",
				"country":"Cape Verde",
				"dialCode":"+238",
				"countryCode":"CV"
			},
			{
				"id":39,
				"name":"+ 345 Cayman Islands [KY]",
				"country":"Cayman Islands",
				"dialCode":"+ 345",
				"countryCode":"KY"
			},
			{
				"id":40,
				"name":"+236 Central African Republic [CF]",
				"country":"Central African Republic",
				"dialCode":"+236",
				"countryCode":"CF"
			},
			{
				"id":41,
				"name":"+235 Chad [TD]",
				"country":"Chad",
				"dialCode":"+235",
				"countryCode":"TD"
			},
			{
				"id":42,
				"name":"+56 Chile [CL]",
				"country":"Chile",
				"dialCode":"+56",
				"countryCode":"CL"
			},
			{
				"id":43,
				"name":"+86 China [CN]",
				"country":"China",
				"dialCode":"+86",
				"countryCode":"CN"
			},
			{
				"id":44,
				"name":"+61 Christmas Island [CX]",
				"country":"Christmas Island",
				"dialCode":"+61",
				"countryCode":"CX"
			},
			{
				"id":45,
				"name":"+61 Cocos (Keeling) Islands [CC]",
				"country":"Cocos (Keeling) Islands",
				"dialCode":"+61",
				"countryCode":"CC"
			},
			{
				"id":46,
				"name":"+57 Colombia [CO]",
				"country":"Colombia",
				"dialCode":"+57",
				"countryCode":"CO"
			},
			{
				"id":47,
				"name":"+269 Comoros [KM]",
				"country":"Comoros",
				"dialCode":"+269",
				"countryCode":"KM"
			},
			{
				"id":48,
				"name":"+242 Congo [CG]",
				"country":"Congo",
				"dialCode":"+242",
				"countryCode":"CG"
			},
			{
				"id":49,
				"name":"+243 Congo, The Democratic Republic of the Congo [CD]",
				"country":"Congo, The Democratic Republic of the Congo",
				"dialCode":"+243",
				"countryCode":"CD"
			},
			{
				"id":50,
				"name":"+682 Cook Islands [CK]",
				"country":"Cook Islands",
				"dialCode":"+682",
				"countryCode":"CK"
			},
			{
				"id":51,
				"name":"+506 Costa Rica [CR]",
				"country":"Costa Rica",
				"dialCode":"+506",
				"countryCode":"CR"
			},
			{
				"id":52,
				"name":"+225 Cote d'Ivoire [CI]",
				"country":"Cote d'Ivoire",
				"dialCode":"+225",
				"countryCode":"CI"
			},
			{
				"id":53,
				"name":"+385 Croatia [HR]",
				"country":"Croatia",
				"dialCode":"+385",
				"countryCode":"HR"
			},
			{
				"id":54,
				"name":"+53 Cuba [CU]",
				"country":"Cuba",
				"dialCode":"+53",
				"countryCode":"CU"
			},
			{
				"id":55,
				"name":"+357 Cyprus [CY]",
				"country":"Cyprus",
				"dialCode":"+357",
				"countryCode":"CY"
			},
			{
				"id":56,
				"name":"+420 Czech Republic [CZ]",
				"country":"Czech Republic",
				"dialCode":"+420",
				"countryCode":"CZ"
			},
			{
				"id":57,
				"name":"+45 Denmark [DK]",
				"country":"Denmark",
				"dialCode":"+45",
				"countryCode":"DK"
			},
			{
				"id":58,
				"name":"+253 Djibouti [DJ]",
				"country":"Djibouti",
				"dialCode":"+253",
				"countryCode":"DJ"
			},
			{
				"id":59,
				"name":"+1767 Dominica [DM]",
				"country":"Dominica",
				"dialCode":"+1767",
				"countryCode":"DM"
			},
			{
				"id":60,
				"name":"+1849 Dominican Republic [DO]",
				"country":"Dominican Republic",
				"dialCode":"+1849",
				"countryCode":"DO"
			},
			{
				"id":61,
				"name":"+593 Ecuador [EC]",
				"country":"Ecuador",
				"dialCode":"+593",
				"countryCode":"EC"
			},
			{
				"id":62,
				"name":"+20 Egypt [EG]",
				"country":"Egypt",
				"dialCode":"+20",
				"countryCode":"EG"
			},
			{
				"id":63,
				"name":"+503 El Salvador [SV]",
				"country":"El Salvador",
				"dialCode":"+503",
				"countryCode":"SV"
			},
			{
				"id":64,
				"name":"+240 Equatorial Guinea [GQ]",
				"country":"Equatorial Guinea",
				"dialCode":"+240",
				"countryCode":"GQ"
			},
			{
				"id":65,
				"name":"+291 Eritrea [ER]",
				"country":"Eritrea",
				"dialCode":"+291",
				"countryCode":"ER"
			},
			{
				"id":66,
				"name":"+372 Estonia [EE]",
				"country":"Estonia",
				"dialCode":"+372",
				"countryCode":"EE"
			},
			{
				"id":67,
				"name":"+251 Ethiopia [ET]",
				"country":"Ethiopia",
				"dialCode":"+251",
				"countryCode":"ET"
			},
			{
				"id":68,
				"name":"+500 Falkland Islands (Malvinas) [FK]",
				"country":"Falkland Islands (Malvinas)",
				"dialCode":"+500",
				"countryCode":"FK"
			},
			{
				"id":69,
				"name":"+298 Faroe Islands [FO]",
				"country":"Faroe Islands",
				"dialCode":"+298",
				"countryCode":"FO"
			},
			{
				"id":70,
				"name":"+679 Fiji [FJ]",
				"country":"Fiji",
				"dialCode":"+679",
				"countryCode":"FJ"
			},
			{
				"id":71,
				"name":"+358 Finland [FI]",
				"country":"Finland",
				"dialCode":"+358",
				"countryCode":"FI"
			},
			{
				"id":72,
				"name":"+33 France [FR]",
				"country":"France",
				"dialCode":"+33",
				"countryCode":"FR"
			},
			{
				"id":73,
				"name":"+594 French Guiana [GF]",
				"country":"French Guiana",
				"dialCode":"+594",
				"countryCode":"GF"
			},
			{
				"id":74,
				"name":"+689 French Polynesia [PF]",
				"country":"French Polynesia",
				"dialCode":"+689",
				"countryCode":"PF"
			},
			{
				"id":75,
				"name":"+241 Gabon [GA]",
				"country":"Gabon",
				"dialCode":"+241",
				"countryCode":"GA"
			},
			{
				"id":76,
				"name":"+220 Gambia [GM]",
				"country":"Gambia",
				"dialCode":"+220",
				"countryCode":"GM"
			},
			{
				"id":77,
				"name":"+995 Georgia [GE]",
				"country":"Georgia",
				"dialCode":"+995",
				"countryCode":"GE"
			},
			{
				"id":78,
				"name":"+49 Germany [DE]",
				"country":"Germany",
				"dialCode":"+49",
				"countryCode":"DE"
			},
			{
				"id":79,
				"name":"+233 Ghana [GH]",
				"country":"Ghana",
				"dialCode":"+233",
				"countryCode":"GH"
			},
			{
				"id":80,
				"name":"+350 Gibraltar [GI]",
				"country":"Gibraltar",
				"dialCode":"+350",
				"countryCode":"GI"
			},
			{
				"id":81,
				"name":"+30 Greece [GR]",
				"country":"Greece",
				"dialCode":"+30",
				"countryCode":"GR"
			},
			{
				"id":82,
				"name":"+299 Greenland [GL]",
				"country":"Greenland",
				"dialCode":"+299",
				"countryCode":"GL"
			},
			{
				"id":83,
				"name":"+1473 Grenada [GD]",
				"country":"Grenada",
				"dialCode":"+1473",
				"countryCode":"GD"
			},
			{
				"id":84,
				"name":"+590 Guadeloupe [GP]",
				"country":"Guadeloupe",
				"dialCode":"+590",
				"countryCode":"GP"
			},
			{
				"id":85,
				"name":"+1671 Guam [GU]",
				"country":"Guam",
				"dialCode":"+1671",
				"countryCode":"GU"
			},
			{
				"id":86,
				"name":"+502 Guatemala [GT]",
				"country":"Guatemala",
				"dialCode":"+502",
				"countryCode":"GT"
			},
			{
				"id":87,
				"name":"+44 Guernsey [GG]",
				"country":"Guernsey",
				"dialCode":"+44",
				"countryCode":"GG"
			},
			{
				"id":88,
				"name":"+224 Guinea [GN]",
				"country":"Guinea",
				"dialCode":"+224",
				"countryCode":"GN"
			},
			{
				"id":89,
				"name":"+245 Guinea-Bissau [GW]",
				"country":"Guinea-Bissau",
				"dialCode":"+245",
				"countryCode":"GW"
			},
			{
				"id":90,
				"name":"+595 Guyana [GY]",
				"country":"Guyana",
				"dialCode":"+595",
				"countryCode":"GY"
			},
			{
				"id":91,
				"name":"+509 Haiti [HT]",
				"country":"Haiti",
				"dialCode":"+509",
				"countryCode":"HT"
			},
			{
				"id":92,
				"name":"+379 Holy See (Vatican City State) [VA]",
				"country":"Holy See (Vatican City State)",
				"dialCode":"+379",
				"countryCode":"VA"
			},
			{
				"id":93,
				"name":"+504 Honduras [HN]",
				"country":"Honduras",
				"dialCode":"+504",
				"countryCode":"HN"
			},
			{
				"id":94,
				"name":"+852 Hong Kong [HK]",
				"country":"Hong Kong",
				"dialCode":"+852",
				"countryCode":"HK"
			},
			{
				"id":95,
				"name":"+36 Hungary [HU]",
				"country":"Hungary",
				"dialCode":"+36",
				"countryCode":"HU"
			},
			{
				"id":96,
				"name":"+354 Iceland [IS]",
				"country":"Iceland",
				"dialCode":"+354",
				"countryCode":"IS"
			},
			{
				"id":97,
				"name":"+91 India [IN]",
				"country":"India",
				"dialCode":"+91",
				"countryCode":"IN"
			},
			{
				"id":98,
				"name":"+62 Indonesia [ID]",
				"country":"Indonesia",
				"dialCode":"+62",
				"countryCode":"ID"
			},
			{
				"id":99,
				"name":"+98 Iran, Islamic Republic of Persian Gulf [IR]",
				"country":"Iran, Islamic Republic of Persian Gulf",
				"dialCode":"+98",
				"countryCode":"IR"
			},
			{
				"id":100,
				"name":"+964 Iraq [IQ]",
				"country":"Iraq",
				"dialCode":"+964",
				"countryCode":"IQ"
			},
			{
				"id":101,
				"name":"+353 Ireland [IE]",
				"country":"Ireland",
				"dialCode":"+353",
				"countryCode":"IE"
			},
			{
				"id":102,
				"name":"+44 Isle of Man [IM]",
				"country":"Isle of Man",
				"dialCode":"+44",
				"countryCode":"IM"
			},
			{
				"id":103,
				"name":"+972 Israel [IL]",
				"country":"Israel",
				"dialCode":"+972",
				"countryCode":"IL"
			},
			{
				"id":104,
				"name":"+39 Italy [IT]",
				"country":"Italy",
				"dialCode":"+39",
				"countryCode":"IT"
			},
			{
				"id":105,
				"name":"+1876 Jamaica [JM]",
				"country":"Jamaica",
				"dialCode":"+1876",
				"countryCode":"JM"
			},
			{
				"id":106,
				"name":"+81 Japan [JP]",
				"country":"Japan",
				"dialCode":"+81",
				"countryCode":"JP"
			},
			{
				"id":107,
				"name":"+44 Jersey [JE]",
				"country":"Jersey",
				"dialCode":"+44",
				"countryCode":"JE"
			},
			{
				"id":108,
				"name":"+962 Jordan [JO]",
				"country":"Jordan",
				"dialCode":"+962",
				"countryCode":"JO"
			},
			{
				"id":109,
				"name":"+77 Kazakhstan [KZ]",
				"country":"Kazakhstan",
				"dialCode":"+77",
				"countryCode":"KZ"
			},
			{
				"id":110,
				"name":"+254 Kenya [KE]",
				"country":"Kenya",
				"dialCode":"+254",
				"countryCode":"KE"
			},
			{
				"id":111,
				"name":"+686 Kiribati [KI]",
				"country":"Kiribati",
				"dialCode":"+686",
				"countryCode":"KI"
			},
			{
				"id":112,
				"name":"+850 Korea, Democratic People's Republic of Korea [KP]",
				"country":"Korea, Democratic People's Republic of Korea",
				"dialCode":"+850",
				"countryCode":"KP"
			},
			{
				"id":113,
				"name":"+82 Korea, Republic of South Korea [KR]",
				"country":"Korea, Republic of South Korea",
				"dialCode":"+82",
				"countryCode":"KR"
			},
			{
				"id":114,
				"name":"+965 Kuwait [KW]",
				"country":"Kuwait",
				"dialCode":"+965",
				"countryCode":"KW"
			},
			{
				"id":115,
				"name":"+996 Kyrgyzstan [KG]",
				"country":"Kyrgyzstan",
				"dialCode":"+996",
				"countryCode":"KG"
			},
			{
				"id":116,
				"name":"+856 Laos [LA]",
				"country":"Laos",
				"dialCode":"+856",
				"countryCode":"LA"
			},
			{
				"id":117,
				"name":"+371 Latvia [LV]",
				"country":"Latvia",
				"dialCode":"+371",
				"countryCode":"LV"
			},
			{
				"id":118,
				"name":"+961 Lebanon [LB]",
				"country":"Lebanon",
				"dialCode":"+961",
				"countryCode":"LB"
			},
			{
				"id":119,
				"name":"+266 Lesotho [LS]",
				"country":"Lesotho",
				"dialCode":"+266",
				"countryCode":"LS"
			},
			{
				"id":120,
				"name":"+231 Liberia [LR]",
				"country":"Liberia",
				"dialCode":"+231",
				"countryCode":"LR"
			},
			{
				"id":121,
				"name":"+218 Libyan Arab Jamahiriya [LY]",
				"country":"Libyan Arab Jamahiriya",
				"dialCode":"+218",
				"countryCode":"LY"
			},
			{
				"id":122,
				"name":"+423 Liechtenstein [LI]",
				"country":"Liechtenstein",
				"dialCode":"+423",
				"countryCode":"LI"
			},
			{
				"id":123,
				"name":"+370 Lithuania [LT]",
				"country":"Lithuania",
				"dialCode":"+370",
				"countryCode":"LT"
			},
			{
				"id":124,
				"name":"+352 Luxembourg [LU]",
				"country":"Luxembourg",
				"dialCode":"+352",
				"countryCode":"LU"
			},
			{
				"id":125,
				"name":"+853 Macao [MO]",
				"country":"Macao",
				"dialCode":"+853",
				"countryCode":"MO"
			},
			{
				"id":126,
				"name":"+389 Macedonia [MK]",
				"country":"Macedonia",
				"dialCode":"+389",
				"countryCode":"MK"
			},
			{
				"id":127,
				"name":"+261 Madagascar [MG]",
				"country":"Madagascar",
				"dialCode":"+261",
				"countryCode":"MG"
			},
			{
				"id":128,
				"name":"+265 Malawi [MW]",
				"country":"Malawi",
				"dialCode":"+265",
				"countryCode":"MW"
			},
			{
				"id":129,
				"name":"+60 Malaysia [MY]",
				"country":"Malaysia",
				"dialCode":"+60",
				"countryCode":"MY"
			},
			{
				"id":130,
				"name":"+960 Maldives [MV]",
				"country":"Maldives",
				"dialCode":"+960",
				"countryCode":"MV"
			},
			{
				"id":131,
				"name":"+223 Mali [ML]",
				"country":"Mali",
				"dialCode":"+223",
				"countryCode":"ML"
			},
			{
				"id":132,
				"name":"+356 Malta [MT]",
				"country":"Malta",
				"dialCode":"+356",
				"countryCode":"MT"
			},
			{
				"id":133,
				"name":"+692 Marshall Islands [MH]",
				"country":"Marshall Islands",
				"dialCode":"+692",
				"countryCode":"MH"
			},
			{
				"id":134,
				"name":"+596 Martinique [MQ]",
				"country":"Martinique",
				"dialCode":"+596",
				"countryCode":"MQ"
			},
			{
				"id":135,
				"name":"+222 Mauritania [MR]",
				"country":"Mauritania",
				"dialCode":"+222",
				"countryCode":"MR"
			},
			{
				"id":136,
				"name":"+230 Mauritius [MU]",
				"country":"Mauritius",
				"dialCode":"+230",
				"countryCode":"MU"
			},
			{
				"id":137,
				"name":"+262 Mayotte [YT]",
				"country":"Mayotte",
				"dialCode":"+262",
				"countryCode":"YT"
			},
			{
				"id":138,
				"name":"+52 Mexico [MX]",
				"country":"Mexico",
				"dialCode":"+52",
				"countryCode":"MX"
			},
			{
				"id":139,
				"name":"+691 Micronesia, Federated States of Micronesia [FM]",
				"country":"Micronesia, Federated States of Micronesia",
				"dialCode":"+691",
				"countryCode":"FM"
			},
			{
				"id":140,
				"name":"+373 Moldova [MD]",
				"country":"Moldova",
				"dialCode":"+373",
				"countryCode":"MD"
			},
			{
				"id":141,
				"name":"+377 Monaco [MC]",
				"country":"Monaco",
				"dialCode":"+377",
				"countryCode":"MC"
			},
			{
				"id":142,
				"name":"+976 Mongolia [MN]",
				"country":"Mongolia",
				"dialCode":"+976",
				"countryCode":"MN"
			},
			{
				"id":143,
				"name":"+382 Montenegro [ME]",
				"country":"Montenegro",
				"dialCode":"+382",
				"countryCode":"ME"
			},
			{
				"id":144,
				"name":"+1664 Montserrat [MS]",
				"country":"Montserrat",
				"dialCode":"+1664",
				"countryCode":"MS"
			},
			{
				"id":145,
				"name":"+212 Morocco [MA]",
				"country":"Morocco",
				"dialCode":"+212",
				"countryCode":"MA"
			},
			{
				"id":146,
				"name":"+258 Mozambique [MZ]",
				"country":"Mozambique",
				"dialCode":"+258",
				"countryCode":"MZ"
			},
			{
				"id":147,
				"name":"+95 Myanmar [MM]",
				"country":"Myanmar",
				"dialCode":"+95",
				"countryCode":"MM"
			},
			{
				"id":148,
				"name":"+264 Namibia [NA]",
				"country":"Namibia",
				"dialCode":"+264",
				"countryCode":"NA"
			},
			{
				"id":149,
				"name":"+674 Nauru [NR]",
				"country":"Nauru",
				"dialCode":"+674",
				"countryCode":"NR"
			},
			{
				"id":150,
				"name":"+977 Nepal [NP]",
				"country":"Nepal",
				"dialCode":"+977",
				"countryCode":"NP"
			},
			{
				"id":151,
				"name":"+31 Netherlands [NL]",
				"country":"Netherlands",
				"dialCode":"+31",
				"countryCode":"NL"
			},
			{
				"id":152,
				"name":"+599 Netherlands Antilles [AN]",
				"country":"Netherlands Antilles",
				"dialCode":"+599",
				"countryCode":"AN"
			},
			{
				"id":153,
				"name":"+687 New Caledonia [NC]",
				"country":"New Caledonia",
				"dialCode":"+687",
				"countryCode":"NC"
			},
			{
				"id":154,
				"name":"+64 New Zealand [NZ]",
				"country":"New Zealand",
				"dialCode":"+64",
				"countryCode":"NZ"
			},
			{
				"id":155,
				"name":"+505 Nicaragua [NI]",
				"country":"Nicaragua",
				"dialCode":"+505",
				"countryCode":"NI"
			},
			{
				"id":156,
				"name":"+227 Niger [NE]",
				"country":"Niger",
				"dialCode":"+227",
				"countryCode":"NE"
			},
			{
				"id":157,
				"name":"+234 Nigeria [NG]",
				"country":"Nigeria",
				"dialCode":"+234",
				"countryCode":"NG"
			},
			{
				"id":158,
				"name":"+683 Niue [NU]",
				"country":"Niue",
				"dialCode":"+683",
				"countryCode":"NU"
			},
			{
				"id":159,
				"name":"+672 Norfolk Island [NF]",
				"country":"Norfolk Island",
				"dialCode":"+672",
				"countryCode":"NF"
			},
			{
				"id":160,
				"name":"+1670 Northern Mariana Islands [MP]",
				"country":"Northern Mariana Islands",
				"dialCode":"+1670",
				"countryCode":"MP"
			},
			{
				"id":161,
				"name":"+47 Norway [NO]",
				"country":"Norway",
				"dialCode":"+47",
				"countryCode":"NO"
			},
			{
				"id":162,
				"name":"+968 Oman [OM]",
				"country":"Oman",
				"dialCode":"+968",
				"countryCode":"OM"
			},
			{
				"id":163,
				"name":"+92 Pakistan [PK]",
				"country":"Pakistan",
				"dialCode":"+92",
				"countryCode":"PK"
			},
			{
				"id":164,
				"name":"+680 Palau [PW]",
				"country":"Palau",
				"dialCode":"+680",
				"countryCode":"PW"
			},
			{
				"id":165,
				"name":"+970 Palestinian Territory, Occupied [PS]",
				"country":"Palestinian Territory, Occupied",
				"dialCode":"+970",
				"countryCode":"PS"
			},
			{
				"id":166,
				"name":"+507 Panama [PA]",
				"country":"Panama",
				"dialCode":"+507",
				"countryCode":"PA"
			},
			{
				"id":167,
				"name":"+675 Papua New Guinea [PG]",
				"country":"Papua New Guinea",
				"dialCode":"+675",
				"countryCode":"PG"
			},
			{
				"id":168,
				"name":"+595 Paraguay [PY]",
				"country":"Paraguay",
				"dialCode":"+595",
				"countryCode":"PY"
			},
			{
				"id":169,
				"name":"+51 Peru [PE]",
				"country":"Peru",
				"dialCode":"+51",
				"countryCode":"PE"
			},
			{
				"id":170,
				"name":"+63 Philippines [PH]",
				"country":"Philippines",
				"dialCode":"+63",
				"countryCode":"PH"
			},
			{
				"id":171,
				"name":"+872 Pitcairn [PN]",
				"country":"Pitcairn",
				"dialCode":"+872",
				"countryCode":"PN"
			},
			{
				"id":172,
				"name":"+48 Poland [PL]",
				"country":"Poland",
				"dialCode":"+48",
				"countryCode":"PL"
			},
			{
				"id":173,
				"name":"+351 Portugal [PT]",
				"country":"Portugal",
				"dialCode":"+351",
				"countryCode":"PT"
			},
			{
				"id":174,
				"name":"+1939 Puerto Rico [PR]",
				"country":"Puerto Rico",
				"dialCode":"+1939",
				"countryCode":"PR"
			},
			{
				"id":175,
				"name":"+974 Qatar [QA]",
				"country":"Qatar",
				"dialCode":"+974",
				"countryCode":"QA"
			},
			{
				"id":176,
				"name":"+40 Romania [RO]",
				"country":"Romania",
				"dialCode":"+40",
				"countryCode":"RO"
			},
			{
				"id":177,
				"name":"+7 Russia [RU]",
				"country":"Russia",
				"dialCode":"+7",
				"countryCode":"RU"
			},
			{
				"id":178,
				"name":"+250 Rwanda [RW]",
				"country":"Rwanda",
				"dialCode":"+250",
				"countryCode":"RW"
			},
			{
				"id":179,
				"name":"+262 Reunion [RE]",
				"country":"Reunion",
				"dialCode":"+262",
				"countryCode":"RE"
			},
			{
				"id":180,
				"name":"+590 Saint Barthelemy [BL]",
				"country":"Saint Barthelemy",
				"dialCode":"+590",
				"countryCode":"BL"
			},
			{
				"id":181,
				"name":"+290 Saint Helena, Ascension and Tristan Da Cunha [SH]",
				"country":"Saint Helena, Ascension and Tristan Da Cunha",
				"dialCode":"+290",
				"countryCode":"SH"
			},
			{
				"id":182,
				"name":"+1869 Saint Kitts and Nevis [KN]",
				"country":"Saint Kitts and Nevis",
				"dialCode":"+1869",
				"countryCode":"KN"
			},
			{
				"id":183,
				"name":"+1758 Saint Lucia [LC]",
				"country":"Saint Lucia",
				"dialCode":"+1758",
				"countryCode":"LC"
			},
			{
				"id":184,
				"name":"+590 Saint Martin [MF]",
				"country":"Saint Martin",
				"dialCode":"+590",
				"countryCode":"MF"
			},
			{
				"id":185,
				"name":"+508 Saint Pierre and Miquelon [PM]",
				"country":"Saint Pierre and Miquelon",
				"dialCode":"+508",
				"countryCode":"PM"
			},
			{
				"id":186,
				"name":"+1784 Saint Vincent and the Grenadines [VC]",
				"country":"Saint Vincent and the Grenadines",
				"dialCode":"+1784",
				"countryCode":"VC"
			},
			{
				"id":187,
				"name":"+685 Samoa [WS]",
				"country":"Samoa",
				"dialCode":"+685",
				"countryCode":"WS"
			},
			{
				"id":188,
				"name":"+378 San Marino [SM]",
				"country":"San Marino",
				"dialCode":"+378",
				"countryCode":"SM"
			},
			{
				"id":189,
				"name":"+239 Sao Tome and Principe [ST]",
				"country":"Sao Tome and Principe",
				"dialCode":"+239",
				"countryCode":"ST"
			},
			{
				"id":190,
				"name":"+966 Saudi Arabia [SA]",
				"country":"Saudi Arabia",
				"dialCode":"+966",
				"countryCode":"SA"
			},
			{
				"id":191,
				"name":"+221 Senegal [SN]",
				"country":"Senegal",
				"dialCode":"+221",
				"countryCode":"SN"
			},
			{
				"id":192,
				"name":"+381 Serbia [RS]",
				"country":"Serbia",
				"dialCode":"+381",
				"countryCode":"RS"
			},
			{
				"id":193,
				"name":"+248 Seychelles [SC]",
				"country":"Seychelles",
				"dialCode":"+248",
				"countryCode":"SC"
			},
			{
				"id":194,
				"name":"+232 Sierra Leone [SL]",
				"country":"Sierra Leone",
				"dialCode":"+232",
				"countryCode":"SL"
			},
			{
				"id":195,
				"name":"+65 Singapore [SG]",
				"country":"Singapore",
				"dialCode":"+65",
				"countryCode":"SG"
			},
			{
				"id":196,
				"name":"+421 Slovakia [SK]",
				"country":"Slovakia",
				"dialCode":"+421",
				"countryCode":"SK"
			},
			{
				"id":197,
				"name":"+386 Slovenia [SI]",
				"country":"Slovenia",
				"dialCode":"+386",
				"countryCode":"SI"
			},
			{
				"id":198,
				"name":"+677 Solomon Islands [SB]",
				"country":"Solomon Islands",
				"dialCode":"+677",
				"countryCode":"SB"
			},
			{
				"id":199,
				"name":"+252 Somalia [SO]",
				"country":"Somalia",
				"dialCode":"+252",
				"countryCode":"SO"
			},
			{
				"id":200,
				"name":"+27 South Africa [ZA]",
				"country":"South Africa",
				"dialCode":"+27",
				"countryCode":"ZA"
			},
			{
				"id":201,
				"name":"+211 South Sudan [SS]",
				"country":"South Sudan",
				"dialCode":"+211",
				"countryCode":"SS"
			},
			{
				"id":202,
				"name":"+500 South Georgia and the South Sandwich Islands [GS]",
				"country":"South Georgia and the South Sandwich Islands",
				"dialCode":"+500",
				"countryCode":"GS"
			},
			{
				"id":203,
				"name":"+34 Spain [ES]",
				"country":"Spain",
				"dialCode":"+34",
				"countryCode":"ES"
			},
			{
				"id":204,
				"name":"+94 Sri Lanka [LK]",
				"country":"Sri Lanka",
				"dialCode":"+94",
				"countryCode":"LK"
			},
			{
				"id":205,
				"name":"+249 Sudan [SD]",
				"country":"Sudan",
				"dialCode":"+249",
				"countryCode":"SD"
			},
			{
				"id":206,
				"name":"+597 Suriname [SR]",
				"country":"Suriname",
				"dialCode":"+597",
				"countryCode":"SR"
			},
			{
				"id":207,
				"name":"+47 Svalbard and Jan Mayen [SJ]",
				"country":"Svalbard and Jan Mayen",
				"dialCode":"+47",
				"countryCode":"SJ"
			},
			{
				"id":208,
				"name":"+268 Swaziland [SZ]",
				"country":"Swaziland",
				"dialCode":"+268",
				"countryCode":"SZ"
			},
			{
				"id":209,
				"name":"+46 Sweden [SE]",
				"country":"Sweden",
				"dialCode":"+46",
				"countryCode":"SE"
			},
			{
				"id":210,
				"name":"+41 Switzerland [CH]",
				"country":"Switzerland",
				"dialCode":"+41",
				"countryCode":"CH"
			},
			{
				"id":211,
				"name":"+963 Syrian Arab Republic [SY]",
				"country":"Syrian Arab Republic",
				"dialCode":"+963",
				"countryCode":"SY"
			},
			{
				"id":212,
				"name":"+886 Taiwan [TW]",
				"country":"Taiwan",
				"dialCode":"+886",
				"countryCode":"TW"
			},
			{
				"id":213,
				"name":"+992 Tajikistan [TJ]",
				"country":"Tajikistan",
				"dialCode":"+992",
				"countryCode":"TJ"
			},
			{
				"id":214,
				"name":"+255 Tanzania, United Republic of Tanzania [TZ]",
				"country":"Tanzania, United Republic of Tanzania",
				"dialCode":"+255",
				"countryCode":"TZ"
			},
			{
				"id":215,
				"name":"+66 Thailand [TH]",
				"country":"Thailand",
				"dialCode":"+66",
				"countryCode":"TH"
			},
			{
				"id":216,
				"name":"+670 Timor-Leste [TL]",
				"country":"Timor-Leste",
				"dialCode":"+670",
				"countryCode":"TL"
			},
			{
				"id":217,
				"name":"+228 Togo [TG]",
				"country":"Togo",
				"dialCode":"+228",
				"countryCode":"TG"
			},
			{
				"id":218,
				"name":"+690 Tokelau [TK]",
				"country":"Tokelau",
				"dialCode":"+690",
				"countryCode":"TK"
			},
			{
				"id":219,
				"name":"+676 Tonga [TO]",
				"country":"Tonga",
				"dialCode":"+676",
				"countryCode":"TO"
			},
			{
				"id":220,
				"name":"+1868 Trinidad and Tobago [TT]",
				"country":"Trinidad and Tobago",
				"dialCode":"+1868",
				"countryCode":"TT"
			},
			{
				"id":221,
				"name":"+216 Tunisia [TN]",
				"country":"Tunisia",
				"dialCode":"+216",
				"countryCode":"TN"
			},
			{
				"id":222,
				"name":"+90 Turkey [TR]",
				"country":"Turkey",
				"dialCode":"+90",
				"countryCode":"TR"
			},
			{
				"id":223,
				"name":"+993 Turkmenistan [TM]",
				"country":"Turkmenistan",
				"dialCode":"+993",
				"countryCode":"TM"
			},
			{
				"id":224,
				"name":"+1649 Turks and Caicos Islands [TC]",
				"country":"Turks and Caicos Islands",
				"dialCode":"+1649",
				"countryCode":"TC"
			},
			{
				"id":225,
				"name":"+688 Tuvalu [TV]",
				"country":"Tuvalu",
				"dialCode":"+688",
				"countryCode":"TV"
			},
			{
				"id":226,
				"name":"+256 Uganda [UG]",
				"country":"Uganda",
				"dialCode":"+256",
				"countryCode":"UG"
			},
			{
				"id":227,
				"name":"+380 Ukraine [UA]",
				"country":"Ukraine",
				"dialCode":"+380",
				"countryCode":"UA"
			},
			{
				"id":228,
				"name":"+971 United Arab Emirates [AE]",
				"country":"United Arab Emirates",
				"dialCode":"+971",
				"countryCode":"AE"
			},
			{
				"id":229,
				"name":"+44 United Kingdom [GB]",
				"country":"United Kingdom",
				"dialCode":"+44",
				"countryCode":"GB"
			},
			{
				"id":230,
				"name":"+1 United States [US]",
				"country":"United States",
				"dialCode":"+1",
				"countryCode":"US"
			},
			{
				"id":231,
				"name":"+598 Uruguay [UY]",
				"country":"Uruguay",
				"dialCode":"+598",
				"countryCode":"UY"
			},
			{
				"id":232,
				"name":"+998 Uzbekistan [UZ]",
				"country":"Uzbekistan",
				"dialCode":"+998",
				"countryCode":"UZ"
			},
			{
				"id":233,
				"name":"+678 Vanuatu [VU]",
				"country":"Vanuatu",
				"dialCode":"+678",
				"countryCode":"VU"
			},
			{
				"id":234,
				"name":"+58 Venezuela, Bolivarian Republic of Venezuela [VE]",
				"country":"Venezuela, Bolivarian Republic of Venezuela",
				"dialCode":"+58",
				"countryCode":"VE"
			},
			{
				"id":235,
				"name":"+84 Vietnam [VN]",
				"country":"Vietnam",
				"dialCode":"+84",
				"countryCode":"VN"
			},
			{
				"id":236,
				"name":"+1284 Virgin Islands, British [VG]",
				"country":"Virgin Islands, British",
				"dialCode":"+1284",
				"countryCode":"VG"
			},
			{
				"id":237,
				"name":"+1340 Virgin Islands, U.S. [VI]",
				"country":"Virgin Islands, U.S.",
				"dialCode":"+1340",
				"countryCode":"VI"
			},
			{
				"id":238,
				"name":"+681 Wallis and Futuna [WF]",
				"country":"Wallis and Futuna",
				"dialCode":"+681",
				"countryCode":"WF"
			},
			{
				"id":239,
				"name":"+967 Yemen [YE]",
				"country":"Yemen",
				"dialCode":"+967",
				"countryCode":"YE"
			},
			{
				"id":240,
				"name":"+260 Zambia [ZM]",
				"country":"Zambia",
				"dialCode":"+260",
				"countryCode":"ZM"
			},
			{
				"id":241,
				"name":"+263 Zimbabwe [ZW]",
				"country":"Zimbabwe",
				"dialCode":"+263",
				"countryCode":"ZW"
			}
		]
	},
	"Call":
	{
		"SC_CONNECTION_TIMEOUT": 50000,
		"ICE_CONNTECTION_TIMEOUT": 15000,
		"CALLING_TIMEOUT": 70000,
		"BANDWIDTH": 600,
		"SDP_CONSTRAINTS":
		{
			"VoiceActivityDetection": false,
			"OfferToReceiveAudio": true,
			"OfferToReceiveVideo": true
		},
		"MEDIA_STATE_TYPE":
		{
			"VIDEO": "VIDEO",
			"HOLD": "HOLD"
		},
		"CALL_TYPE":
		{
			"NONE": "NONE",
			"OUTGOING": "OUTGOING",
			"INCOMING": "INCOMING",
			"DISABLED": "DISABLED"
		},
		"HANGUP_DETAIL":
		{
			"NORMAL_CLEARING": "NORMAL_CLEARING",
			"SIGNAL_CLIENT_CONNECTION_LOST": "SIGNAL_CLIENT_CONNECTION_LOST",
			"ICE_CONNECTION_LOST": "ICE_CONNECTION_LOST",
			"ORIGINATOR_CANCEL": "ORIGINATOR_CANCEL",
			"PROGRESS_TIMEOUT": "PROGRESS_TIMEOUT"
		}
	},
	"Broadcast":
	{
		"Chat":
		{
			"OPEN": "CHAT.OPEN",
			"CLOSE": "CHAT.CLOSE",
			"DESTROY": "CHAT.DESTROY",
			"INIT": "CHAT.INIT",
			"NEW": "CHAT.NEW",
			"UPDATE_LAST_POST_SEEN": "CHAT.UPDATE.LAST.POST.SEEN",
			"UPDATE_CHAT_STATUS": "CHAT.UPDATE.CHAT.STATUS",
			"MESSAGE_SENT": "CHAT.MESSAGE.SENT",
			"NEW_MESSAGE": "CHAT.NEW.MESSAGE",
			"NEW_EVENT": "CHAT.NEW.EVENT",
			"CHAT_POST_EDITED": "CHAT.POST.EDITED",
			"CHAT_POST_DELETED": "CHAT.POST.DELETED",
			"FOCUS_INPUT": "CHAT.FOCUS_INPUT",
			"MEDIA_UPLOAD_INIT": "CHAT.MEDIA_UPLOAD_INIT",
			"MEDIA_UPLOAD_START": "CHAT.MEDIA_UPLOAD_START",
			"MEDIA_UPLOAD_ERROR": "CHAT.MEDIA_UPLOAD_ERROR"
		},
		"Call":
		{
			"AUTHENTICATED": "SC.AUTHENTICATION.SUCCESS",
			"AUTHENTICATION_FAILED": "SC.AUTHENTICATION.FAILED",
			"CONTACT_UPDATE": "SC.ON.CONTACT.UPDATE",
			"REQUEST_CALL": "SC.ON.REQUEST.CALL",
			"CALL_ACCEPTED": "SC.ON.CALL.ACCEPTED",
			"CALL_ENDED": "SC.ON.CALL.ENDED",
			"RTC_OFFER": "SC.ON.RTC.OFFER",
			"RTC_ANSWER": "SC.ON.RTC.ANSWER",
			"ICE_CANDIDATE": "SC.ON.RTC.ICE.CANDIDATE"
		},
		"Modal":
		{
			"MEDIA_OPEN": "MODAL_MEDIA_OPEN",
			"MEDIA_CLOSING": "MODAL_MEDIA_CLOSING",
			"EMPLOYER_INVITE_CONFIRMATION_CLOSING": "EMPLOYER_INVITE_CONFIRMATION_CLOSING"
		},
		"Session":
		{
			"LOGIN": "LOG.IN",
			"LOGOUT": "LOG.OUT",
			"INIT_CALL_CLIENT": "INIT.CALL.CLIENT",
			"INIT_CHAT": "INIT.CHAT",
			"INIT_PUSH_NOTIFICATIONS": "INIT.PUSH.NOTIFICATIONS",
			"CONTACTS_UPDATE": "SESSION.CONTACTS.UPDATE",
			"UPDATE": "SESSION.UPDATE",
			"CONTACT_UPDATE": "SESSION.CONTACTS.UPDATE",
			"CONTACT_REMOVED": "SESSION.CONTACTS.REMOVED",
			"CONTACT_ADDED": "SESSION.CONTACTS.ADDED",
			"REQUEST_UPDATE": "SESSION.REQUESTS.UPDATE",
			"DESTROY": "SESSION:DESTROY"
		},
		"Profile":
		{
			"UPDATE": "PROFILE.UPDATE",
			"MEDIA_UPLOAD_INIT": "PROFILE.MEDIA_UPLOAD_INIT",
			"MEDIA_UPLOAD_START": "PROFILE.MEDIA_UPLOAD_START",
			"MEDIA_UPLOAD_ERROR": "PROFILE.MEDIA_UPLOAD_ERROR"
		},
		"Notifications":
		{
			"COUNT": "NOTIFICATIONS.COUNT"
		},
		"Dictionary":
		{
			"LOADED": "DICTIONARY.LOADED"
		},
		"Feed":
		{
			"LIKE_TOGGLE": "FEED.LIKE.TOGGLE",
			"NEW_POST": "FEED.NEW.POST",
			"NEW_COMMENT": "FEED.COMMENT.NEW",
			"COMMENT_EDITED": "FEED.COMMENT.EDITED"
		},
		"Group":
		{
			"JOIN": "GROUP.JOIN",
			"LEAVE": "GROUP.LEAVE",
			"REQUEST_ACCEPTED": "GROUP.JOIN.REQUEST.ACCEPTED",
			"REQUEST_REJECTED": "GROUP.JOIN.REQUEST.REJECTED",
			"UPDATE_NOTIFICATIONS": "GROUP.UPDATE.NOTIFICATIONS",
			"INVITES_ADDED": "GROUP.INVITES.ADDED",
			"INVITES_REMOVED": "GROUP.INVITES.REMOVED"
		},
		"Services":
		{
			"BOOKING_CANCELLED": "SERVICES.BOOKING_CANCELLED",
			"SEARCH": "SERVICES.SEARCH",
			"UPDATED": "SERVICES.UPDATED"
		},
		"Wallet":
		{
			"FUNDS_ADDED": "WALLET.FUNDS_ADDED",
			"CC_ADDED": "WALLET.CC_ADDED"
		},
		"Bookings":
		{
			"INITIALIZED": "BOOKINGS.INITIALIZED",
			"ADDED": "BOOKINGS.ADDED",
			"REMOVED": "BOOKINGS.REMOVED",
			"COUNT": "BOOKINGS.COUNT",
			"RESCHEDULE": "BOOKINGS.RESCHEDULE.",
			"REINITIALIZE": "BOOKINGS.REINITIALIZE"
		},
		"Instant_Bookings":
		{
			"STATUS_CHANGED": "INSTANT_BOOKINGS.STATUS_CHANGED"
		},
		"Employees":
		{
			"ADDED": "EMPLOYEES.ADDED"
		},
		"Dependents":
		{
			"ADDED": "DEPENDENTS.ADDED"
		},
		"Symptom_Check":
		{
			"RATING_UPDATED": "SYMPTOM_CHECK.RATING_UPDATED"
		}
	},
	"Timer":
	{
		"Call":
		{
			"CALLING_TIMER": "CALL.CALLING.TIMER",
			"REQUEST_DISCONNECTED": "CALL.REQUEST.DISCONNECTED",
			"CALL_DISCONNECTED": "CALL.CALL.DISCONNECTED"
		},
		"Chat":
		{
			"AUDIO_MESSAGE": "CALL.AUDIO_MESSAGE.TIMER",
			"STATUS": "CHAT.STATUS.TIMER"
		}
	},
	"Other":
	{
		"LOADER_TIMEOUT_INIT": 50,
		"LOADER_TIMEOUT_DELAY": 500,
		"INSURANCE_CHANGE_DELAY_IN_DAYS": 4
	},
	"Booking":
	{
		"Instant":
		{
			"STORAGE_KEY": "gvR9Tf",
			"SECONDS_PENDING": 300,
			"SECONDS_STATUS_AVAILABLE": 1800,
			"SECONDS_STATUS_CONFIRM": 60,
			"Doctor":
			{
				"DEFAULT_PRICE": 15,
				"DEFAULT_CURRENCY": "EUR",
				"DEFAULT_DURATION_MINUTES": 15
			},
			"Pharmacist":
			{
				"DEFAULT_PRICE": 0,
				"DEFAULT_CURRENCY": "EUR",
				"DEFAULT_DURATION_MINUTES": 10
			},
			"Nurse":
			{
				"DEFAULT_PRICE": 30,
				"DEFAULT_CURRENCY": "EUR",
				"DEFAULT_DURATION_MINUTES": 0
			},
			"Prescription":
			{
				"DEFAULT_PRICE": 5,
				"DEFAULT_CURRENCY": "EUR",
				"DEFAULT_DURATION_MINUTES": 0
			},
			"Coach":
            {
                "DEFAULT_PRICE": 58,
                "DEFAULT_CURRENCY": "EUR",
                "DEFAULT_DURATION_MINUTES": 50
            },
			"WeightLoss":
			{
				"DEFAULT_PRICE": 65,
				"DEFAULT_CURRENCY": "EUR",
				"DEFAULT_DURATION_MINUTES": 0
			}
		}
	},
	"Symptom_Check":
	{
		"STORAGE_KEY": "interview"
	},
	"Pharmacy":
	{
		"PURCHASING_SUPPORTED": true,
		"MEDICATION_SEARCH_SUPPORTED": true
	},
    "PreVisit":
    {
        "PHOTO_UPLOAD_ENABLED": true
    }
}
